"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
exports.Loading = ({ color, icon, message, useLogo, children, }) => {
    let contents = (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: color || 'text-dark', icon: pro_light_svg_icons_1.faSpinnerThird, spin: true, size: "3x" }));
    if (icon) {
        contents = icon;
    }
    else if (useLogo) {
        contents = react_1.default.createElement(react_2.OsmosysLogo, { height: "100px", width: "100px" });
    }
    return (react_1.default.createElement("div", { className: "flex-full-col-centered h-100" },
        react_1.default.createElement("div", { className: "flex-full-row-centered" },
            react_1.default.createElement("div", { className: "flex-full-col-centered" },
                react_1.default.createElement("div", { className: "text-center" },
                    contents,
                    message && (react_1.default.createElement("p", { className: "lead mt-2 mb-0 text-center", "data-name": "loading-message" }, message)),
                    children)))));
};
//# sourceMappingURL=Loading.js.map